import React from "react";
import PropTypes from "prop-types";
import { SFUseStyled, SFIconButton, SFIcons, SFStack } from "@sf-core";

const { styled } = SFUseStyled();

const SFIconButtonStyled = styled(SFIconButton)(() => ({}));

const ToggleMasterDetailCell = ({ node, api, data, ...props }) => {
  const toggleMasterDetails = () => {
    let _expanded = !data.expanded;
    let _data = { ...data, expanded: _expanded };
    node.setData(_data);
  };

  return (
    <SFStack
      alignItems="center"
      justifyContent="center"
      style={{ height: "100%" }}
    >
      <SFIconButtonStyled variant="unhovered" onClick={toggleMasterDetails}>
        {data.expanded ? (
          <SFIcons.SFArrowUpIcon color="primary" />
        ) : (
          <SFIcons.SFArrowDownIcon color="primary" />
        )}
      </SFIconButtonStyled>
    </SFStack>
  );
};

ToggleMasterDetailCell.propTypes = {
  data: PropTypes.object,
  api: PropTypes.object,
  nameKey: PropTypes.string,
  descriptionKey: PropTypes.string,
  context: PropTypes.object,
  node: PropTypes.object,
};

export default ToggleMasterDetailCell;
